import languageService from '../../services/localization/languageService';

const getLocalizedPropertyOrDefault = (propertyPath) => {
    const language = languageService.getCurrentLanguageCode();
    const targetConfigProp = propertyPath?.[language?.toLowerCase()];

    return targetConfigProp ? targetConfigProp : propertyPath;
};

export default {
    getLocalizedPropertyOrDefault,
};
